import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { Checkbox } from "../ui/checkbox";
import { Scroll } from "lucide-react";

const STORAGE_KEY = "kf_post_policy_seen";

// One-time posting-policy notice shown the first time a Knight opens the post composer —
// mirrors KfOnboardingModal's localStorage-per-user pattern, no backend field needed.
export function KfPostPolicyModal({ open, onOpenChange, userId, onContinue }) {
  const [dontShowAgain, setDontShowAgain] = useState(true);

  const continueToComposer = () => {
    if (dontShowAgain) {
      const seen = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      if (!seen.includes(userId)) localStorage.setItem(STORAGE_KEY, JSON.stringify([...seen, userId]));
    }
    onOpenChange(false);
    onContinue();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md bg-[#322216] border-white/10 text-[#f1e0c5]" data-testid="kf-post-policy-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl flex items-center gap-2">
            <Scroll className="w-5 h-5 text-[#D4AF37]" /> Before You Post
          </DialogTitle>
          <DialogDescription className="sr-only">Knights Fee posting policy</DialogDescription>
        </DialogHeader>
        <p className="text-sm text-[#f1e0c5]/70 leading-relaxed">
          Hi! Just here to let you know out posting policies before you post. We try and keep
          PG-13 rules around here, and we expect you too as well. A few swear word occasionally
          aren't bad, but please mind your tongue. Same goes for pictured content, skin is fine to
          the extent that someone under the age of 18 is allowed to see it. Have fun, find
          adventures, and beware.
        </p>
        <label className="flex items-center gap-2 text-xs cursor-pointer">
          <Checkbox data-testid="kf-post-policy-dont-show-checkbox" checked={dontShowAgain} onCheckedChange={setDontShowAgain} />
          Don't show this again
        </label>
        <Button data-testid="kf-post-policy-continue-button" onClick={continueToComposer} className="w-full rounded-full bg-[#D90429] hover:bg-[#b8031f] uppercase tracking-widest text-xs">
          I Understand
        </Button>
      </DialogContent>
    </Dialog>
  );
}

export function hasSeenKfPostPolicy(userId) {
  const seen = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  return seen.includes(userId);
}
